import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoadingSpinner } from '@/components';
import { useIsAdmin } from '@/hooks/useAuth';
import { useSpaceAccess } from '@/contexts/SpaceAccessContext';
import { useFeatureGate } from '@statsig/react-bindings';
import ConfigLayout from './config';
import SharingLayout from './sharing';

const ApiTokens = lazy(() => import('./config/ApiTokens'));
const WebhookSettings = lazy(() => import('./config/WebhookSettings'));
const AlertSettings = lazy(() => import('./config/AlertSettings'));
const PublicUrlSettings = lazy(() => import('./sharing/PublicUrlSettings'));

export const ConnectPage = () => {
  const isAdmin = useIsAdmin();
  const { value: connectPageEnabled } = useFeatureGate('connect_page');
  const { isLoading } = useSpaceAccess();
  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAdmin || !connectPageEnabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="bg-surface-sunken w-full">
      <Routes>
        <Route path="/connect/config" element={<ConfigLayout />}>
          <Route
            path="api-tokens"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <ApiTokens />
              </Suspense>
            }
          />
          <Route
            path="webhooks"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <WebhookSettings />
              </Suspense>
            }
          />
          <Route
            path="alerts"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <AlertSettings />
              </Suspense>
            }
          />
          <Route index element={<Navigate to="api-tokens" replace />} />
        </Route>
        <Route path="/connect/sharing" element={<SharingLayout />}>
          <Route
            path="public-urls"
            element={
              <Suspense fallback={<LoadingSpinner />}>
                <PublicUrlSettings />
              </Suspense>
            }
          />
          <Route index element={<Navigate to="public-urls" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/connect/config/api-tokens" replace />} />
      </Routes>
    </div>
  );
};

export default ConnectPage;
